import {
    Form,
    Input,
    Button,
    Select,
    Result,
} from "antd";
import { useState } from "react";
import { useForm } from "antd/lib/form/Form";
import {
    signularisApi,
    useCreateMetaDocumentMutation,
    useGetRecipientsListQuery, 
    useGetSelfInfoQuery
} from "../../../store/api/signularisApi";
import { useSelector } from "react-redux";
import genDocument1 from '../misc/gendoc1';
import { RootState } from "../../../store/store";
import { useAppDispatch } from "../../../hooks/redux";
import { CREATE_DOCUMENT_ROUTE, MAIN_PAGE_ROUTE } from "../../../routing/consts";
import { Link } from "react-router-dom";
import { DocTemplateType } from "../../../types/types";
import style from '../CreateDocument.module.scss';
import { SendOutlined } from "@ant-design/icons";

const { Item } = Form;
const { TextArea } = Input;
const { Option } = Select;

// Генерирует случайный ID для документа
let guid = () => {
    let s4 = () => {
        return Math.floor((1 + Math.random()) * 0x100)
            .toString(10)
            .substring(1);
    }
    return s4() + s4() + s4() + s4();
}

// Форматирование даты для документа
function styledDate() {
    const months = ["января", "февраля", "марта", "апреля", "мая", "июня", "июля",
        "августа", "сентября", "октября", "ноября", "декабря"]
    const dobj = new Date()
    return `${dobj.getDate()} ${months[dobj.getMonth()]} ${dobj.getFullYear()}`
}

type DocumentTitle1 = 'Ректору ГГНТУ \nМинцаеву М. Ш.' | 'Проректору по АХЧ \nЧегарбиеву А.С.'
export const documentTitle1: DocumentTitle1[] = ['Ректору ГГНТУ \nМинцаеву М. Ш.', 'Проректору по АХЧ \nЧегарбиеву А.С.']

function Template() {
    const info = useSelector((state: RootState) => state.userinfo)
    const dispatch = useAppDispatch()

    const { data: recipients } = useGetRecipientsListQuery()
    const { data: newUsInfo } = useGetSelfInfoQuery()

    const defaulRepicients = ["62567bcc72944c7123ebde5a", '62303f756315cc23e79ca2c9', newUsInfo?.id]
    const recipientsList = recipients?.filter(item => !defaulRepicients.includes(item.id)) || []

    const [docname, setDocname] = useState("")
    const docTemplate: DocTemplateType = 'extractStorage'

    const [createMetaDocument, {
        isLoading: mutationLoading,
        isSuccess: mutationSuccess,
        isError: mutationError,
    }] = useCreateMetaDocumentMutation()

    const [form] = useForm()

    const onFinish = async (values: any) => {
        const regnum = guid()
        setDocname('Заявка на выписку из склада')
        const formData = new FormData()
        formData.append("title", `Заявка на выписку из склада №${regnum}`)
        formData.append("brief", "Сгенерировано из шаблона")
        formData.append("recipients", values.recipients?.length ? values.recipients.join(",") + ',' + defaulRepicients.join(",") : defaulRepicients.join(","))
        formData.append("documentType", docTemplate)
        
        const templateValues = { ...values, regnum, regdate: styledDate(), dutyface: `${info.lastname} ${info.firstname} ${info.middlename}` }
        const pdfBytes = await genDocument1(templateValues, info)

        formData.append("file", new Blob([pdfBytes]))
        createMetaDocument(formData)
        dispatch(signularisApi.util.invalidateTags(['MetaDocument']))
    }

    if (mutationSuccess) {
        return (
            <Result
                status="success"
                title="Документ создан"
                subTitle={`Ваш документ ${docname} успешно создан.`}
                extra={[
                    <Link key="back" to={MAIN_PAGE_ROUTE + '/' + CREATE_DOCUMENT_ROUTE}>
                        <Button type="primary">Создать еще</Button>
                    </Link>
                ]}
            />
        )
    }

    if (mutationError) {
        return (
            <Result
                status="error"
                title="Не удалось создать документ"
                extra={[
                    <Link key="back" to={MAIN_PAGE_ROUTE + '/' + CREATE_DOCUMENT_ROUTE}>
                        <Button>Попробовать снова</Button>
                    </Link>
                ]}
            />
        )
    }

    return (
        <div className={style.generatorWrapper}>
            <h2 className={style.title}>Выписка из склада</h2>
            
            <div className={style.alertInfo}>
                При создании заявки на выписку компьютерного оборудования или оргтехники необходимо в получателях
                указать проректора по ЦиИ ПАШАЕВА М.Я. В остальных случаях укажите КУРИРУЮЩЕГО ПРОРЕКТОРА.
            </div>

            <Form 
                form={form} 
                onFinish={onFinish} 
                layout="vertical"
                initialValues={{regtext: "Прошу Вас выписать со склада "}}
            >
                <Item label="Дополнительные получатели" name="recipients" initialValue={[]}>
                    <Select
                        mode="multiple"
                        allowClear
                        placeholder="Выберите из списка..."
                        size="large"
                        filterOption={(input, option) =>
                            (option?.label as string ?? '').toLowerCase().includes(input.toLowerCase())
                        }
                    >
                         {recipientsList?.map((recipient) => (
                            <Option key={recipient.id} value={recipient.id} label={recipient.fullname}>
                            {recipient.fullname} {!!recipient.position && <>- <span style={{color: 'gray', fontSize: 12}}>{recipient.position}</span></>}
                            </Option>
                        ))}
                    </Select>
                </Item>

                <div className={style.recipientTags}>
                    <span className={style.tag}>Магомедов Тимур Эейсаевич</span>
                    <span className={style.tag}>Чегарбиев Адлан Сулейманович</span>
                </div>

                <Item 
                    label="Заявка на имя" 
                    name="docTitle" 
                    rules={[{required: true, message: 'Обязательное поле'}]}
                >
                    <Select placeholder="Кому адресован документ?" size="large">
                        {documentTitle1.map((title) => (
                            <Option key={title} value={title}>{title}</Option>
                        ))}
                    </Select>
                </Item>

                <Item 
                    label="Текст заявки" 
                    name="regtext" 
                    rules={[{required: true, message: 'Обязательное поле'}]}
                >
                    <TextArea rows={5} placeholder="Укажите, что именно необходимо выписать..." />
                </Item>

                <Button 
                    type="primary" 
                    htmlType="submit" 
                    loading={mutationLoading}
                    size="large"
                    icon={<SendOutlined style={{ display: 'inline-flex', alignSelf: 'center' }} />}
                    style={{ 
                        display: 'inline-flex', 
                        alignItems: 'center', 
                        justifyContent: 'center',
                        width: '100%',
                        marginTop: '10px'
                    }}
                >
                    Создать документ
                </Button>
            </Form>
        </div>
    )
}

export default Template;
